function handleClick(target, currrentList, args) {
    const { node1, node2, list1, list2 } = args;

    target.className = 'rank-item active';
    node1.className = 'rank-item';
    node2.className = 'rank-item';

    currrentList.className = 'list-content-videos active';
    list1.className = 'list-content-videos';
    list2.className = 'list-content-videos';
}

export default function (target) {
    let btns = target.parentElement.getElementsByClassName('rank-item');
    let videoLists = target.parentElement.parentElement.parentElement.querySelectorAll('.list-content-videos');
    const currIndex = [].indexOf.call(btns, target);
    const currentVideoList = videoLists[currIndex];

    btns = [].slice.call(btns, 0, currIndex).concat([].slice.call(btns, currIndex + 1));
    videoLists = [].slice.call(videoLists, 0, currIndex).concat([].slice.call(videoLists, currIndex + 1));

    handleClick(target, currentVideoList, {
        node1: btns[0],
        node2: btns[1],
        list1: videoLists[0],
        list2: videoLists[1],
    });
}